export default __webpack_public_path__ + "static/media/luxemburg.b4b91188.jpg";